import { render, staticRenderFns } from "./ParametrsList.vue?vue&type=template&id=44a6437c"
import script from "./ParametrsList.vue?vue&type=script&lang=js"
export * from "./ParametrsList.vue?vue&type=script&lang=js"
import style0 from "./ParametrsList.vue?vue&type=style&index=0&id=44a6437c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports